module.exports = __webpack_public_path__ + "static/media/sort-amount-up.58e3ca91.svg";